exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".separator{border-bottom:1px solid #ddd;margin-bottom:20px}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/admin/Fields/EditField.vue"],"names":[],"mappings":"AACA,WACE,6BAAiC,AACjC,kBAAoB,CACrB","file":"EditField.vue","sourcesContent":["\n.separator {\n  border-bottom: 1px #dddddd solid;\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73eb5548","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/Fields/EditField.vue
// module id = 1020
// module chunks = 9